import { render, staticRenderFns } from "./HazirEvrakGonderIslemDetayView.vue?vue&type=template&id=3737c048&scoped=true"
import script from "./HazirEvrakGonderIslemDetayView.vue?vue&type=script&lang=ts"
export * from "./HazirEvrakGonderIslemDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3737c048",
  null
  
)

export default component.exports